<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <div :class="b('buy')">
      <SharedSelect
        view="light"
        :options="buyCurrencyOptions"
        :icon="buyCurrencyIcon"
        v-model:value="buyCurrencySelected.value"
      />
      <p :class="b('label')">{{ $t("Покупка") }}</p>
      <p :class="b('value')">{{ formatRate(buyRate) }}</p>
    </div>

    <div :class="b('sell')">
      <SharedSelect
        view="light"
        :options="sellCurrencyOptions"
        :icon="sellCurrencyIcon"
        v-model:value="sellCurrencySelected.value"
      />
      <p :class="b('label')">{{ $t("Продажа") }}</p>
      <p :class="b('value')">{{ formatRate(sellRate) }}</p>
    </div>
  </div>
</template>
